import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbEscolaridade } from 'app/abstract/full-pages/customs/escolaridade/escolaridade.abstract';

@Injectable({ providedIn: 'root' })
export class EscolaridadeService extends AbEscolaridade {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllEscolaridades(): Observable<any> {
    return this.get("public/escolaridades/");
  }

}